const prodURL =
  process.env.NEXT_PUBLIC_BASE_URL ||
  "https://real-time-detection-production.up.railway.app/api";
const devURL =
  process.env.NEXT_PUBLIC_DEV_BASE_URL ||
  "https://real-time-detection-dev.up.railway.app/api";
// Use VERCEL_ENV to accurately separate production vs preview/staging
const isProd = process.env.VERCEL_ENV === "production";

const apiConfig = {
  prodURL,
  devURL,

  api: {
    baseUrl: isProd ? prodURL : devURL,
    permitUrl: process.env.NEXT_PUBLIC_DRIVER_PERMIT_API_URL,
  },

  environment:
    process.env.NEXT_PUBLIC_ENV || process.env.VERCEL_ENV || "development",
  isDevelopment: process.env.VERCEL_ENV === "development",
  isProduction: isProd,

  features: {
    debug: process.env.DEBUG === "true",
    securityHeaders: process.env.NEXT_PUBLIC_SECURITY_HEADERS === "true",
  },
};

export default apiConfig;
